// src/pages/ChallengeDetail.js
import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import ChallengeDetailCard from './components/challengedetail/ChallengeDetailCard';
import instance from '../api/axiosConfig';
import { useUser } from "../context/UserContext";
import JWTService from '../services/JWTService';
import { ArrowLeft, CircleCheckBig, Text } from "lucide-react"
import Firework from './common/Firework'

const ChallengeDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { user, loginUser } = useUser(); // Use context

    const [chanllengeInfo, setChallengeInfo] = useState(null);
    const [showFirework, setShowFirework] = useState(false);

    useEffect(() => {
        if (!user || (user && JWTService.isTokenExpired(user.token))) navigate("/login");

    })

    // Fetch items for the challenge from the backend API
    const fetchItems = async () => {
        try {
            const response = await instance.get(`/challenge/get?challengeId=${id}&userId=` + user.guid); // Replace with your API endpoint
            setChallengeInfo(response.data);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    useEffect(() => {
        fetchItems();
    }, [id]);

    const handleUpdate = async () => {
        let data = {
            challengeDetailId: id,
            userId: user.guid,
            title: '',
            note: '',
            icon: '',
            isCompleted: true
        }
        // Gọi API để cập nhật item
        try {
            const responseData = await instance.put(`/challengedetail`, data); // Replace with your API endpoint
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    const handleComplete = async (itemId) => {
        let data = {
            challengeDetailId: itemId,
            userId: user.guid
        }
        try {
            const responseData = await instance.put(`/challengedetail/markcompleted`, data); // Replace with your API endpoint
            setShowFirework(true); // Show firework on completion
            var timer = setTimeout(() => setShowFirework(false), 10000); // Hide firework after 5 seconds
            clearTimeout(timer)
        } catch (error) {
            console.error('Error fetching items:', error);
        }
        fetchItems();
    };

    return (
        <div className="bg-[#efefef] text-[#333c4d] min-h-screen p-4">
            {showFirework && <Firework run={showFirework} />}
            <div className="flex items-center justify-between mb-2">
                <Link to="/app" className="inline-flex items-center text-gray-600">
                    <ArrowLeft className="w-5 h-5 mr-1" />
                    BACK
                </Link>
                <div>
                    <h1 className="text-2xl font-bold center ">
                        Challenge Detail
                        <span className="inline-block ml-1 border-b-2 border-red-500"></span>
                    </h1>
                </div>
            </div>
            <div className="bg-gradient-to-r from-yellow-400 via-red-500 min-h-screen p-4 rounded-lg">
                <h1 className="text-4xl font-bold text-left text-white mb-4">{chanllengeInfo && chanllengeInfo.challenge.TotalDay} DAYS</h1>
                <div className="flex justify-between mb-4">
                    <div className="text-white">
                        <strong>Date:</strong> {chanllengeInfo && chanllengeInfo.challenge.start} - {chanllengeInfo && chanllengeInfo.challenge.end}
                    </div>
                    <div className="text-white">
                        <strong>Goal:</strong> {chanllengeInfo && chanllengeInfo.challenge.title}
                    </div>
                    <div className="text-white">
                        <strong>Memo:</strong> [Ghi chú]
                    </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {chanllengeInfo && chanllengeInfo.challengeDetails.map((item, index) => (
                        <div
                            key={index}
                            className={`p-4 rounded-lg bg-white`}
                        >
                            <h2 className="text-xl font-bold">{item.order}. {item.title}</h2>
                            <p className="text-sm text-gray-600">Schedule Date: {item.scheduleDate}</p>
                            <p className="text-sm text-gray-600">Actual Date: {item.actualDate}</p>
                            <div className="flex items-center justify-center mt-2">
                                {item.isMissed ? <> </> : item.isCompleted ? <><div className='w-full text-center pt-3'>
                                    <CircleCheckBig color='green' width={36} className='mr-2 inline-block' />
                                </div></> : <button
                                    className="w-full bg-white hover:bg-gray-100 text-green-500 border border-green-500 rounded-lg py-3 font-medium transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center"
                                    onClick={() => {
                                        handleComplete(item.id)
                                    }}
                                >
                                    <Text color='green' width={18} className='mr-2' />
                                    COMPLETE
                                </button>}
                            </div>
                            <p className="text-sm text-gray-600 mt-2">Note: {item.note}</p>
                        </div>
                    ))}
                </div>
            </div>

        </div>

    );
};

export default ChallengeDetail;